import { separator } from '../constants';

/**
 * Remove duplicates in an array
 *
 * @example
 * unique(['Bob','Jane','Jane','Julia']);
 * // returns: ['Bob', 'Jane', 'Julia']
 */
export const unique = <T extends any>(
  array: T[],
  findMatchIndex: (array: T[], item: T) => number = (array2: T[], item2: T) =>
    array2.indexOf(item2),
): T[] => {
  return array.filter((item, index) => findMatchIndex(array, item) === index);
};

/**
 * Pluck key values in an array
 *
 * @example
 * pluck('name', [{id: 1, name: 'Bob'}, {id: 2, name: 'Jane'}]);
 * // returns ['Bob', 'Jane']
 */
export const pluck = <
  K extends keyof T & string,
  T extends { [key: string]: any }
>(
  key: K,
  array: T[],
): Array<T[K]> => {
  return array.map(item => item[key]);
};

/**
 * Comma-separated string
 *
 * Given an array of strings, join each array item with ', ' (A.K.A. - 'CSV')
 *
 * @example
 * commaSeparated("John", "Julia", "Jane")
 * // returns: "John, Julia, Jane"
 */
export const commaSeparated = (array: string[]) => array.join(', ');

/**
 * Bullet-separated string
 *
 * Given an array of strings, join each array item with ', ' (A.K.A. - 'CSV')
 *
 * @example
 * commaSeparated("John", "Julia", "Jane")
 * // returns: "John ∙ Julia ∙ Jane"
 */
export const bulletSeparated = (array: string[]) => array.join(separator);
